// The workspace default can point at a team hidden in Linear settings, so it only wins while visible.
export function resolveDefaultTeamId(
	defaultTeamId: string | null | undefined,
	visibleTeams: { id: string }[],
): string | undefined {
	if (defaultTeamId && visibleTeams.some(({ id }) => id === defaultTeamId)) {
		return defaultTeamId
	}
	return visibleTeams[0]?.id
}
